import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const TEXT_POPUP_PADDING = 6;
const EM_SCALE_FACTOR = 10.0;
const BASE_FONT_SIZE = 13.0;
const DEFAULT_FONT_SIZE = 17.0;

// Wraps TextBoxPopups and SignaturePopups
export default class SelfServePopup extends React.PureComponent {
  constructor(props) {
    super(props);

    this.renderWithData = this.renderWithData.bind(this);
    this.renderInactive = this.renderInactive.bind(this);
    this.renderTextPopupWithData = this.renderTextPopupWithData.bind(this);
    this.renderSignaturePopupWithData = this.renderSignaturePopupWithData.bind(this);
    this.renderInactiveSignature = this.renderInactiveSignature.bind(this);
  }

  renderTextPopupWithData() {
    // Scale the default font by the zoom factor
    const scaledFont = DEFAULT_FONT_SIZE * this.props.zoomFactor;
    // Compute the new font based off freewrite scaling logic. See textpopup.jsx
    let computedFont = (scaledFont / EM_SCALE_FACTOR) * BASE_FONT_SIZE;
    computedFont = parseFloat(computedFont.toFixed(2));
    const lineHeight = computedFont + 1;
    return (
      <div
        className="inactive-self-serve-popup-img self-serve-popup with-value"
        style={{
          fontSize: `${computedFont}px`,
          lineHeight: `${lineHeight}px`,
          paddingLeft: `${TEXT_POPUP_PADDING * this.props.zoomFactor}px`,
          paddingRight: `${TEXT_POPUP_PADDING * this.props.zoomFactor}px`,
        }}
      >
        {this.props.userData}
      </div>
    );
  }

  renderSignaturePopupWithData() {
    return (
      <img
        alt="Signature"
        src={this.props.userData}
        style={{
          height: this.props.height,
        }}
        className="self-serve-recipient-signature"
      />
    );
  }

  renderWithData() {
    if (this.props.isSignature) {
      // Add render method to render signature in preview
      return this.renderSignaturePopupWithData();
    }
    return this.renderTextPopupWithData();
  }

  renderInactiveSignature() {
    const popupIndicatorWidth = this.props.height * 1.125;
    const leftOffset = 5;
    const wrapperClasses = classNames(
      'self-serve-recipient-signature',
      {
        'recipient-builder-selected-popup': this.props.isSelected,
      },
    );

    return (
      <div className={wrapperClasses}>
        <div
          className="popup-indicator"
          style={{
            height: this.props.height,
            left: -(popupIndicatorWidth + leftOffset),
            width: popupIndicatorWidth,
          }}
        />
        <div
          className="inactive-self-serve-popup-img self-serve-popup"
          style={{
            width: this.props.width,
            height: this.props.height,
          }}
        />
      </div>
    );
  }

  renderInactive() {
    if (this.props.isSignature) {
      return this.renderInactiveSignature();
    }
    return (
      <div
        className="inactive-self-serve-popup-img self-serve-popup"
        style={{
          width: this.props.width,
          height: this.props.height,
        }}
      />
    );
  }

  render() {
    // We will only have user data if we are in preview mode
    if (this.props.userData && this.props.isPreviewMode) {
      return this.renderWithData();
    }
    // isActive is always false while in preview mode
    if (!this.props.isActive) {
      return this.renderInactive();
    }

    return (
      <React.Fragment>
        { this.props.children }
      </React.Fragment>
    );
  }
}

SelfServePopup.defaultProps = {
  isActive: false,
  isPreviewMode: false,
  isSelected: false,
  isSignature: false,
  children: null,
  userData: '',
  zoomFactor: 1,
};

SelfServePopup.propTypes = {
  isActive: PropTypes.bool,
  isPreviewMode: PropTypes.bool,
  isSelected: PropTypes.bool,
  isSignature: PropTypes.bool,
  children: PropTypes.node,
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  userData: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      type: PropTypes.string,
      url: PropTypes.string,
    }),
  ]),
  zoomFactor: PropTypes.number,
};



// WEBPACK FOOTER //
// ./src-react/Popups/SelfServeBuilderPopups/SelfServePopup.jsx